// client/pages/system/ReleaseDetails.jsx
import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ArrowLeft, Home, Sparkles, Calendar } from "lucide-react";
import { ReleasesAPI } from "../../constants/systemCommsApi.js";
import { useTheme } from "../../context/ThemeContext.jsx";
import MarkdownContent from "../../components/system/MarkdownContent.jsx";
import AppButton from "../../components/ui/AppButton.jsx";
export default function ReleaseDetails() {
  const {
    version
  } = useParams();
    const navigate = useNavigate();
  const [release, setRelease] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    document.title = `Release ${version} • WireTrack`;
    setLoading(true);
    ReleasesAPI.detail(version).then(d => {
      setRelease(d.release);
      setLoading(false);
    }).catch(err => {
      setError(err?.data?.error?.message || "Release nicht gefunden");
      setLoading(false);
    });
  }, [version]);
  if (loading) {
    return <div className={`min-h-screen flex items-center justify-center ${"bg-[#030508]"}`}>
        <div className={`animate-spin w-8 h-8 border-2 border-t-blue-500 rounded-full ${"border-white/10"}`} />
      </div>;
  }
  if (error || !release) {
    return <div className={`min-h-screen flex flex-col items-center justify-center gap-4 ${"bg-[#030508] text-white"}`}>
        <p className="text-lg">{error || "Release nicht gefunden"}</p>
        <Link to="/" className="text-blue-500 hover:underline">Zurück zum Dashboard</Link>
      </div>;
  }
  const body = release.body || {
    sections: []
  };
  const sections = body.sections || [];
  return <div className={`min-h-screen ${"bg-[#030508]"}`}>
      <div className="max-w-3xl mx-auto px-4 py-8">
        <div className="flex items-center gap-3 mb-6">
          <AppButton type="button" variant="ghost" onClick={() => navigate(-1)} className={`!p-2 ${"text-white/50"}`}>
            <ArrowLeft className="w-5 h-5" />
          </AppButton>
          <Link to="/" className={`p-2 rounded-xl transition-colors ${"hover:bg-white/5 text-white/50"}`}>
            <Home className="w-5 h-5" />
          </Link>
        </div>

        <div className={`rounded-2xl border p-6 sm:p-8 ${"bg-[#0c1425] border-white/10"}`}>
          <div className="flex items-center gap-3 mb-2">
            <Sparkles className={`w-5 h-5 ${"text-blue-400"}`} />
            <span className={`text-sm font-mono ${"text-blue-400"}`}>v{release.version}</span>
          </div>

          <h1 className={`text-2xl font-bold mb-2 ${"text-white"}`}>{release.title}</h1>

          {release.created_at && <div className={`flex items-center gap-1.5 text-xs mb-8 ${"text-white/30"}`}>
              <Calendar className="w-3.5 h-3.5" />
              {new Date(release.created_at).toLocaleDateString("de-CH")}
            </div>}

          <div className="space-y-6">
            {sections.map((sec, i) => <div key={i}>
                {sec.heading && <h2 className={`text-lg font-semibold mb-2 ${"text-white"}`}>{sec.heading}</h2>}
                {sec.text && <MarkdownContent>{sec.text}</MarkdownContent>}
                {sec.bullets?.length > 0 && <ul className={`list-disc list-inside space-y-1 text-sm ${"text-white/60"}`}>
                    {sec.bullets.map((b, j) => <li key={j}>{b}</li>)}
                  </ul>}
                {sec.steps?.length > 0 && <ol className={`list-decimal list-inside space-y-1 text-sm ${"text-white/60"}`}>
                    {sec.steps.map((s, j) => <li key={j}>{s}</li>)}
                  </ol>}
              </div>)}
            {sections.length === 0 && <p className={`text-sm ${"text-white/40"}`}>Keine Details verfügbar.</p>}
          </div>
        </div>
      </div>
    </div>;
}